import { createAction, props } from '@ngrx/store';
import { GeoCoordinate } from '@polaris-customerweb/sharedcomponents.shared';

export const getUserLocation = '[user location] get location';
export const getUserLocationSuccess = '[user location] get location success';
export const getUserLocationFail = '[user location] get location fail';

export const UserLocationActions = {
    getUserLocation,
    getUserLocationFail,
    getUserLocationSuccess,
};

export const GetUserLocation = createAction(getUserLocation);

export const GetUserLocationSuccess = createAction(
    getUserLocationSuccess,
    props<{ location: GeoCoordinate }>()
);

export const GetUserLocationFail = createAction(
    getUserLocationFail,
    props<{ errorMessage: string }>()
);
